import React, { useContext } from "react";
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import { ThemeContext } from "../../utils/ThemeContext";

const SettingsMenu = ({
  anchorEl,
  onClose,
  onUserProfile,
  onSystemPreferences,
  onThemeSettings,
  hasPermission,
  collapsed,
}) => {
  const { isDark } = useContext(ThemeContext);

  const menuItems = [
    {
      label: "Profile Settings",
      icon: <AccountCircleIcon fontSize="small" />,
      onClick: onUserProfile,
      permission: "edit_own_profile",
    },
    {
      label: "System Preferences",
      icon: <SettingsIcon fontSize="small" />,
      onClick: onSystemPreferences,
      permission: "manage_settings",
    },
    {
      label: "Theme Settings",
      icon: <ColorLensIcon fontSize="small" />,
      onClick: () => {
        onThemeSettings();
        onClose();
      },
      permission: "manage_theme",
    },
  ];

  const paperBg = isDark
    ? "rgba(26,44,70,0.97)"
    : "rgba(255,255,255,0.96)";
  const paperBorder = isDark
    ? "1px solid rgba(255,255,255,0.08)"
    : "1px solid rgba(47,99,173,0.10)";
  const textColor = isDark ? "#dde5f0" : "#223142";
  const iconColor = isDark ? "#7ab3f0" : "#2f63ad";
  const hoverBg = isDark
    ? "rgba(122,179,240,0.1)"
    : "rgba(47,99,173,0.08)";

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      PaperProps={{
        elevation: 0,
        sx: {
          mt: 1,
          minWidth: 230,
          borderRadius: "16px",
          backgroundColor: paperBg,
          backdropFilter: "blur(12px)",
          boxShadow: isDark
            ? "0 18px 45px rgba(0,0,0,0.45)"
            : "0 18px 45px rgba(0,0,0,0.18)",
          border: paperBorder,
          overflow: "hidden",
          py: 1,
        },
      }}
      MenuListProps={{
        sx: { p: 1 },
      }}
    >
      {menuItems.map(({ label, icon, onClick, permission }) =>
        hasPermission(permission) ? (
          <Tooltip key={label} title={collapsed ? label : ""} placement="right">
            <MenuItem
              onClick={() => {
                onClick();
                onClose();
              }}
              sx={{
                minHeight: 46,
                borderRadius: "12px",
                mx: 0.5,
                my: 0.25,
                px: 1.25,
                transition: "all 0.2s ease",
                color: textColor,
                "&:hover": {
                  backgroundColor: hoverBg,
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36, color: iconColor }}>
                {icon}
              </ListItemIcon>

              {!collapsed && (
                <ListItemText
                  primary={label}
                  primaryTypographyProps={{
                    fontSize: "0.95rem",
                    fontWeight: 600,
                    color: textColor,
                  }}
                />
              )}
            </MenuItem>
          </Tooltip>
        ) : null
      )}
    </Menu>
  );
};

export default SettingsMenu;
